import i18next from 'i18next';

import alerts from 'common/modules/alerts';

import rejectAlliance from './rejectAlliance';

export default (id, callback) => (dispatch) => {
    const dataAlert = {
        haveTextCaptcha: true,
        messages: [
            i18next.t(
                'By rejecting the alliance request you will no longer be able to reverse the changes',
            ),
        ],
        onSuccess: () => dispatch(rejectAlliance(id, callback)),
        textToValidate: i18next.t('Decline').toUpperCase(),
        title: i18next.t('Confirmation'),
        type: alerts.ALERT_TYPE_CONFIRM,
        variant: 'error',
    };

    dispatch(alerts.actions.show(dataAlert));
};
